const ProviderDataFilesController = function ($scope, $http, $rootScope) {
    const PROVIDER_NAMES = Object.freeze({
        'AmazonPay': 'AmazonPay',
    });
    
    $scope.providerNames = PROVIDER_NAMES;

    $scope.amazonPayFileName = '';
    $scope.isAmazonPayFileUploaded = false;

    function tryToGetUploadedFileName(provider) {
        $rootScope.skipErrorBox = true;
        $http({
            method: "GET",
            url: `/api/v1/PaymentProviderFiles/${provider}/filename`,
            cache: false
        }).then(function (response) {
            updateState(provider, true, response.data);
        }, function (){
            updateState(provider, false, '');
        });
    }

    tryToGetUploadedFileName(PROVIDER_NAMES.AmazonPay);

    function updateState(provider, fileUploaded, fileName) {
        if (provider === PROVIDER_NAMES.AmazonPay){
            updateAmazonPayDataState(fileUploaded, fileName);
        }
    }

    function updateAmazonPayDataState(fileUploaded, fileName) {
        $scope.amazonPayFileName = fileName;
        $scope.isAmazonPayFileUploaded = fileUploaded;
    }

    $scope.deleteDataFile = function (provider){
        $http({
            method: "DELETE",
            url: `/api/v1/PaymentProviderFiles/${provider}`,
            cache: false
        }).then(function () {
            updateState(provider, false, '');
        });
    };

    $scope.getUploadActionPath = function (provider){
        return `/api/v1/PaymentProviderFiles/${provider}/upload?access_token=` + encodeURIComponent($rootScope.accessToken);
    };

    $scope.providerDataUploadCompleted = function (content, provider) {
        if (content.status === 'success'){
            tryToGetUploadedFileName(provider);
        }
        else if (content.status === 'error'){
            $scope.notify("error", "Upload error: " + content.message);
        }
    };
};
ProviderDataFilesController.$inject = ["$scope", "$http", "$rootScope"];

angular.module('globalControllers',).controller('ProviderDataFilesController', ProviderDataFilesController);
